export const DEMO_SCHOOL_ID = "64260d45-7131-455e-b720-e17e543289a1";
